import {
    DASHBOARD_ERROR,
    DASHBOARD_SUCCESS,
    IS_LOADING,
} from "../actions/Type";

const initialState = {
    dashboard_list: {},
};

export const DashboardReducrs = (
    state = initialState,
    { type, payload } = {},
) => {
    switch (type) {
        case IS_LOADING:
            return {
                ...state,
                loading: true,
            };
        case DASHBOARD_SUCCESS:
            return {
                ...state,
                dashboard_list: payload,
                loading: false,
            };
        case DASHBOARD_ERROR:
            return {
                ...state,
                dashboard_list: payload,
                loading: false,
            };
        default:
            return state;
    }
};
